import type { SycurioCreatePaymentMethodProps } from '../types/SycurioCreatePaymentMethodProps';
import type { CreatePaymentMethodReq } from '../../../services/customer/types';
import type { Agent } from '../../../services/commonCheckout/types/CheckoutSessionsResponse';

export type GenerateCreatePaymentMethodArgs =
  SycurioCreatePaymentMethodProps & {
    agent: Agent | null;
    vendorPaymentMethodId: string;
  };

export const generateCreatePaymentMethodPayload = ({
  nameOnCard,
  isDefault,
  manufacturerCard,
  nickname,
  agent,
  vendorPaymentMethodId,
  cardCategories,
}: GenerateCreatePaymentMethodArgs): Record<
  'paymentMethod',
  CreatePaymentMethodReq
> => {
  return {
    paymentMethod: {
      type: 'CARD',
      vendorPaymentMethodId,
      vendor: 'STRIPE',
      default: isDefault,
      nickname,
      paymentMethodDetails: {
        type: 'CARD',
        nameOnCard,
        manufacturerCard,
        cardCategories,
      },
      agent,
      authRequired: false,
      sourceProvider: {
        name: 'CCG',
      },
      paymentMethodSourceDetails: {
        channel: 'TELEPHONIC_ENTRY',
        uiSourceFragment: 'SYCURIO',
      },
    },
  };
};
